<template>
<div class="error504">
    <div class="error-img">
        <img class="img" :src="noData" alt="">
    </div>
    <div class="tip">{{errorMsg.error504}}</div>
    <!--<div class="btn"><van-button type="default" size="large" @click="back">返回</van-button></div>-->
</div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
export default {
    name: 'error504',
    data() {
        return {
            noData: require('common/images/mobile/img-noData.png')
        }
    },
    created() {
        document.title = `访问失败`
    },
    mounted() {
    },
    methods: {
        back() {
            this.$router.back()
        },
        ...mapActions([
            'setErrorMsg'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'errorMsg'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/variable";
.error504 {
    height: 100vh;
    background: $c-white;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .error-img{
        width: 1.69rem;
        height: 1.63rem;
        .img{
            width: 100%;
            height: 100%;
        }
    }
    .tip{
        margin-top: 0.5rem;
        font-size: 0.28rem;
        text-align: center;
        margin-bottom: 1rem;
    }
    .btn{
        padding: 0 1.24rem;
        width: calc(100% - 2.48rem);
        font-size: 0.3rem;
        .van-button{
            height: 0.76rem;
            border-radius: 0.38rem;
            line-height: 1;
            color: $c-grey;
        }
    }
}
</style>
